import { useParams, Link, Navigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { useProject } from "../hooks/useProjects";
import "./ProjectDetailPage.css";

function ProjectDetailPage() {
  const { id } = useParams();
  const { t } = useApp();
  const project = useProject(id);

  if (!project) return <Navigate to="/404" replace />;

  const varName = id.replace(/-([a-z])/g, (_, c) => c.toUpperCase());

  return (
    <div className="detail-page page-enter">
      {/* Back */}
      <Link to="/portfolio/projects" className="detail-back syn-comment">
        ← {t("project_detail.back")}
      </Link>

      {/* Import statement style header */}
      <div className="detail-import">
        <span className="syn-pink">import </span>
        <span className="syn-white">{"{ "}</span>
        <span className="syn-lblue">{varName}</span>
        <span className="syn-white">{" }"}</span>
        <span className="syn-pink"> from </span>
        <span className="syn-orange">"./projects/{id}"</span>
        <span className="syn-white">;</span>
      </div>

      {/* Hero image */}
      <div className="detail-img-wrap">
        <div className="detail-img-bar">
          <span className="syn-comment">// {project.title}</span>
          <div className="detail-links">
            {project.liveUrl && (
              <a
                href={project.liveUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="detail-link detail-link--primary"
              >
                ↗ {t("project_detail.live_link")}
              </a>
            )}
            {project.githubUrl && (
              <a
                href={project.githubUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="detail-link detail-link--ghost"
              >
                ⎇ {t("project_detail.github_link")}
              </a>
            )}
          </div>
        </div>
        <img src={project.image} alt={project.title} className="detail-img" />
      </div>

      {/* Object literal body */}
      <div className="detail-code">
        <h2 className="syn-const">{varName}</h2>
        <br />
        <div className="code-line">
          <span className="detail-desc-text">"{project.fullDesc}"</span>
        </div>
        <br />
        {project.liveUrl && (
          <div className="code-line">
            <span className="syn-lightblue">liveUrl</span>
            <span className="syn-white">:&nbsp;</span>
            <span className="syn-orange">"{project.liveUrl}"</span>
            <span className="syn-white">,</span>
          </div>
        )}
        {project.githubUrl && (
          <div className="code-line">
            <span className="syn-lightblue">github</span>
            <span className="syn-white">:&nbsp;</span>
            <span className="syn-orange">"{project.githubUrl}"</span>
            <span className="syn-white">,</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProjectDetailPage;
